export const APP_THEME = 'USER/APP_THEME';
export const BIOMETRIC = 'USER/BIOMETRIC';
